module.exports = __webpack_public_path__ + "img/ship.8da71176.svg";